import React from "react";
import styled from "@emotion/styled";
import { TOOLTIP_SEGMENTED_BAR_HEIGHT, TOOLTIP_SEGMENTED_BAR_TEST_ID } from "./HyroTooltipSection.consts";

// Share bar for tooltip sections; no per-segment interaction — use OutcomeBreakdownBar when
// segments need tooltips or links. segments: [{ key, value, color }], widths are shares of the sum.
const HyroTooltipSegmentedBar = ({ segments = [], height = TOOLTIP_SEGMENTED_BAR_HEIGHT }) => (
  <Bar data-testid={TOOLTIP_SEGMENTED_BAR_TEST_ID} style={{ height }}>
    {segments.filter(({ value }) => value > 0).map(({ key, value, color }) => (
      <Segment key={key} data-testid={`${TOOLTIP_SEGMENTED_BAR_TEST_ID}-${key}`} style={{ flex: value, backgroundColor: color }} />
    ))}
  </Bar>
);

const Bar = styled("div")({
  display: "flex",
  width: "100%",
  borderRadius: 2,
  overflow: "hidden"
});

const Segment = styled("div")({
  minWidth: 1,
  height: "100%"
});

export default HyroTooltipSegmentedBar;
